module.exports = __webpack_public_path__ + "img/slide4.3d1fd81c.jpg";